export const iconFontAwesomePunctuationSymbolsPercent = (
	<i className="fa-solid fa-percent"></i>
);
